<template>
  <div class="million-read-user-certificate-container">
    <div class="million-read-user-certificate-item"
         v-ym-report:MILLION_VIP_USER_CERTIFICATE_ITEM_CLICK="{
           certificateId: item.id,
         }"
         @click="handleClickItem(item.id)"
    >
      <ym-img :src="item.cover"
              class="million-read-user-certificate-item-cover"
      />
      <div class="million-read-user-certificate-item-title ym-two-line-ellipsis">
        {{ item.title }}
      </div>
      <div class="million-read-user-certificate-item-receive-time">
        {{ item.receiveTime | formatTime('yyyy-MM-dd') }} 获得
      </div>
    </div>
    <ym-popup class="million-read-user-certificate-popup"
              v-model="showCertPopup"
              get-container="body"
    >
      <ym-img :src="item.cover"
              class="million-read-user-certificate-popup-cover"
      />
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'MillionReadUserCertificateItem',
    components: {
      'ym-popup': Popup,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showCertPopup: false,
      };
    },
    methods: {
      handleClickItem() {
        this.showCertPopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-user-certificate {
    &-item {
      width: 280px;
      margin-right: @size-base;
      text-align: center;
      &:nth-child(2n) {
        margin-right: 0;
      }
      &-cover {
        width: 280px;
        height: 198px;
        margin-bottom: 16px;
      }
      &-title {
        width: 280px;
        margin-bottom: 8px;
        color: @color-text-base;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
        line-height: 1.5;
      }
      &-receive-time {
        color: @color-text-lighter;
        font-size: @font-size-small;
        line-height: 1;
      }
    }
    &-popup {
      width: 750px;
      background: transparent;
      &-cover {
        width: 750px;
      }
    }
  }


</style>
